import { render, staticRenderFns } from "./HsCodeIRPop.vue?vue&type=template&id=52613952"
import script from "./HsCodeIRPop.vue?vue&type=script&lang=js"
export * from "./HsCodeIRPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52613952')) {
      api.createRecord('52613952', component.options)
    } else {
      api.reload('52613952', component.options)
    }
    module.hot.accept("./HsCodeIRPop.vue?vue&type=template&id=52613952", function () {
      api.rerender('52613952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/HsCodeIRPop.vue"
export default component.exports